module.exports = __webpack_public_path__ + "img/10551399_L.343cc7bc.png";